import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SignalR_Component from 'signalr/App';
import { QueryClient, QueryClientProvider } from 'react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient();
root.render(
  <>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>

  </>
);

const footer = document.createElement('footer');
document.body.appendChild(footer);

footer.className = 'footer';

footer.innerText = '© تمامی حقوق محفوظ است - شایا درمان ';

const separator = document.createElement('span');
separator.innerText = ' | توسعه و طراحی توسط ';
footer.appendChild(separator);

const link = document.createElement('a');
link.href = 'https://www.fprad.com';
link.target = '_blank';
link.rel = 'noopener noreferrer';
link.innerText = 'شرکت فرآیند پرداز راد';
footer.appendChild(link);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
